// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPhoneOff = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M6.506 21l2.021-4.034a15 15 0 01-.886-.84C4.654 13.064 3 8.805 3 4V3h5.986l3.042 3.042-1.857 4.715.978.977 4.378-8.738h2.237L11.05 16.398l-.904 1.803L8.743 21zm2.952-5.89l.746-1.491-2.375-2.376L9.686 6.53 8.157 5h-3.13c.21 3.914 1.662 7.286 4.046 9.73q.189.194.385.38"
    />,
    <path d="M11.882 19.2C14.23 20.363 16.968 21 20 21h1v-5.986l-3.042-3.042-3.058 1.205-1.342 2.678 3.913-1.541L19 15.843v3.131c-2.33-.122-4.417-.67-6.222-1.561z" />
  );
export default SvgIconPhoneOff;
